<template>
  <b-field grouped>
    <base-select
      v-model="contractType"
      :service="$options.contractService"
      fetch-func="listTypes"
      :fetch-params="{
        created_by_firm_id: userFirmId,
      }"
      label="Contract Type"
    />
    <base-select
      v-model="contract"
      :service="$options.contractService"
      fetch-func="all"
      :fetch-params="{
        type_tag_id: contractType,
        includes: 'contractor',
      }"
      :fetch-on-init="false"
      label="Contract"
      default-option-label="All"
      :disabled="!contractType"
      @fetch="(options) => $emit('fetch', options)"
      ref="selectContract"
    >
      <template #customLabel="{ option }">
        {{ `${option.contractor.name} - ${option.name}` }}
      </template>
    </base-select>
  </b-field>
</template>

<script>
import BaseSelect from "@/components/partials/BaseSelect";
import { ContractService } from "@/services/contract.service";

export default {
  contractService: ContractService,
  props: {
    value: {
      type: String,
    },
  },
  components: {
    BaseSelect,
  },
  data: () => ({
    contractType: "",
    contract: "",
  }),
  computed: {
    userFirmId() {
      return this.$store.state.Auth.user.firmId;
    },
  },
  watch: {
    contractType() {
      this.$nextTick(() => {
        this.contract = "";
        if (this.contractType) {
          this.$refs.selectContract.fetchOptions();
        } else {
          this.$refs.selectContract.options = [];
        }
        this.$emit("input-type", this.contractType);
      });
    },
    contract() {
      this.$emit("input", this.contract);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Contract/ContractSelect.vue